import { Component, OnInit, Input, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { faTree } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-cta',
    templateUrl: './cta.component.html',
    styleUrls: ['./cta.component.scss'],
    standalone: false
})
export class CtaComponent implements OnInit {
  @Input() title:string = "Find and Buy O-Rings Online";
  @Input() bulletPoints:string[] = [
    "Standard and Metric Sizes",
    "Thousands of materials",
    "Find O-rings by size, temperature range, material type, compliance, and more"
  ];
  @Input() subPoints:string[] = [];
  @Input() cta:string = "Shop Online";
  @Input() routerLink:string[];
  @Input() textPoints:string[] = []
  @Input() buttonOnly:boolean = false;
  @Input() noButton:boolean = false;
  @Input() titleIcons:boolean = false;
  @Input() ctaClass:string = "cta-container";
  @ViewChild('customTemplate', {static: false}) customTemplate;

  showCustomTemplate:boolean = false;
  faShoppingCart = faShoppingCart;
  faTree = faTree;

  constructor(
    private cdRef:ChangeDetectorRef,
    private router: Router
  ) {}

  ngOnInit() {
  }

  ngAfterViewInit() {
    if (this.customTemplate) {
      this.showCustomTemplate = this.customTemplate.nativeElement && this.customTemplate.nativeElement.children.length > 0;
      this.cdRef.detectChanges();
    }
  }

  navigate() {
    if (!this.routerLink) {
      this.router.navigate(['/store']);
    }
  }
}
